import { Box, Typography } from '@mui/material';
import React from 'react';

export default function PersonCard(props) {

    return(
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", maxWidth: props.small && {md: "20rem", xs: "20rem"}}}>   

            <Box sx={{m: 2}}>
                <img src={props.img} alt={"image of " + props.name} style={{borderRadius: "100px"}} height={props.small ? "100px" : "150px"}/>
            </Box>
        
            <Box sx={{display: "flex", flexDirection: "column", width: 250}}>
                <Typography align="left">{props.university}</Typography>
                <Typography align="left">{props.title}</Typography>
                <Typography align="left"><a href={props.link} style={{ color:"#E50043"}} rel="noreferrer" target="_blank">{props.name}</a></Typography>
                <Typography align="left"><a href={"tel:" + props.phone} style={{ color:"#E50043"}}>{props.phone}</a></Typography>
                <Typography align="left"><a href={"mailto:" + props.mail} style={{ color:"#E50043"}}>{props.mail}</a></Typography>
            </Box>

        </Box>
    )
}